import { Observable } from "rxjs";

import { ArgumentNullError } from "@gp/utility";

import { IEntryNotificationSubscriptionRequest, IEntryNotificationSubscriptionResponse, IConnection } from "../../common";
import { Hub } from "../../Hub";
import { EntryNotificationHubOptions } from "./EntryNotificationHubOptions";

/**
 * EntryNotificationHub is used for real-time entry notifications
 */
export class EntryNotificationHub extends Hub {
	/**
	 * Creates an instance of Entry notification hub
	 * @param options
	 * @param connection 
	 */
	constructor(options: EntryNotificationHubOptions, connection: IConnection) {
		super(options, connection);
	}

	/**
	 * Get entry notifications
	 * @param request subscription request filter
	 * @returns observable that is updated every time new message arrives on the hub
	 */
	getSubscription(request: IEntryNotificationSubscriptionRequest): Observable<IEntryNotificationSubscriptionResponse> {
		if (request == null) {
			throw new ArgumentNullError('request');
		}

		return this.createSubscription<IEntryNotificationSubscriptionResponse>(request.subscriptionId, {
			subscribe: () => this.invoke('Subscribe', request),
			unsubscribe: () => this.invoke('Unsubscribe', { subscriptionId: request.subscriptionId }),
			autoResubscribe: true,
			tryToResubscribeOnError: true
		});
	}
}